var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEstrela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.09,
    height: 19.091,
    viewBox: "0 0 19.09 19.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.818,19.091a.956.956,0,0,1-.93-1.169L4.31,11.763.288,7.843A.955.955,0,0,1,.879,6.207l5.441-.432L8.676.562a.953.953,0,0,1,1.739,0L12.77,5.775l5.441.433a.955.955,0,0,1,.563,1.661l-4.33,3.9,1.746,6.109a.955.955,0,0,1-1.448,1.056l-5.2-3.465-5.2,3.465A.95.95,0,0,1,3.818,19.091ZM9.545,3.274l-1.717,3.8a.953.953,0,0,1-.795.56l-3.9.311,2.9,2.828a.959.959,0,0,1,.263.9l-1,4.339,3.726-2.484a.949.949,0,0,1,1.058,0L13.642,15.9l-1.2-4.186a.953.953,0,0,1,.28-.972l3.122-2.81-3.792-.3a.953.953,0,0,1-.794-.56l-1.717-3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEstrela);
export default __webpack_public_path__ + "static/media/ico-estrela.e3d1ad67fc7bc9eb041f970b23e60cc2.svg";
export { ForwardRef as ReactComponent };